import type { IBlock } from "../BlockList/Block";

/**
 * Filter blocks by a case-insensitive search term matched against
 * `primaryText` (e.g. folder name) and `secondaryText` (e.g. folder number).
 * Returns the full list when the term is empty.
 */
export function filterBlocksBySearch(blocks: IBlock[], searchValue: string): IBlock[] {
	const trimmed = searchValue.trim().toLowerCase();
	if (trimmed.length === 0) return blocks;
	return blocks.filter((block) => {
		const name = block.primaryText?.toLowerCase() ?? "";
		const number = block.secondaryText?.toLowerCase() ?? "";
		return name.includes(trimmed) || number.includes(trimmed);
	});
}
